import { render, staticRenderFns } from "./AddCustomer_Credit.vue?vue&type=template&id=2dfe9bfc&scoped=true&"
import script from "./AddCustomer_Credit.vue?vue&type=script&lang=js&"
export * from "./AddCustomer_Credit.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomer_Credit.vue?vue&type=style&index=0&id=2dfe9bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe9bfc",
  null
  
)

export default component.exports